import React, { useRef, useState, useEffect } from 'react';

import Navbar from "../../components/en/Navbar";
import Footer from "../../components/en/Footer";
import Cta from "../../components/en/CtaNomal";

import "../../styles/common.css";
import "../../styles/company.css";

import imgMemberCeo from "../../img/members/general/ceo.JPG";
import imgMemberCto from "../../img/members/general/cto.JPG";
import imgMemberCfo from "../../img/members/general/cfo.JPG";
import imgMemberCdo from "../../img/members/general/cdo.JPG";


const CompanyEn = () => {

  return (
    <>
      <Navbar></Navbar>
      <main className='company'>
        <section className='fvUnder'>
          <div className='fvUnder-text'>
            <h1>About Us</h1>
            <nav aria-label="Breadcrumb" className="breadcrumb">
              <ol className='breadcrumb'>
                <li><a href="/en">Home</a></li>
                <li aria-current="page">About LOGOT</li>
              </ol>
            </nav>
          </div>
        </section>
        <section className='about'>
          <div className="title">
            <p className='title-lead'>ABOUT</p>
            <h2>Company Overview - LOGOT</h2>
          </div>
          <p>LOGOT UG provides comprehensive support for Japanese companies expanding into global markets and leveraging cross-border e-commerce (EC) for growth.<br />Our mission is to equip businesses with the tools and expertise needed for a smooth entry into international markets. From digital marketing and localization to logistics support, we offer a one-stop solution for global success.<br />Founded in 2024 and headquartered in Dusseldorf, Germany, we combine technology, creative solutions, and deep market expertise to help businesses thrive. With our digital marketing and e-commerce expertise, we empower clients to expand their business in Europe and beyond, reaching new customer segments and driving sustainable growth.</p>
        </section>
        <section className='member'>
          <div className="title">
            <p className='title-lead'>MEMBER</p>
            <h2>Teams</h2>
          </div>
          <div className='member-box flex'>
            <div className='member-box__item'>
              <div className='member-item__image'>
                <img src={imgMemberCeo} alt="" />
              </div>
              <div className='member-item__text'>
                <p className='member-text__post'>CEO</p>
                <p className='member-text__name'>Shinzo Hata</p>
                <p className='member-text__detail'>A Visionary Leader Guiding Clients in Global Expansion.</p>
              </div>
            </div>
            <div className='member-box__item'>
              <div className='member-item__image'>
                <img src={imgMemberCto} alt="" />
              </div>
              <div className='member-item__text'>
                <p className='member-text__post'>CTO</p>
                <p className='member-text__name'>Ko Watanabe</p>
                <p className='member-text__detail'>IT Expert Supporting Seamless E-Commerce Operations with Cutting-Edge Technologies.</p>
              </div>
            </div>
            <div className='member-box__item'>
              <div className='member-item__image'>
                <img src={imgMemberCfo} alt="" />
              </div>
              <div className='member-item__text'>
                <p className='member-text__post'>Localization</p>
                <p className='member-text__name'>A.K</p>
                <p className='member-text__detail'>Native Level Japanese & English, Fluent in German -- Crafting Brand Strategies Optimized for Local Culture & Language.</p>
              </div>
            </div>
            <div className='member-box__item'>
              <div className='member-item__image'>
                <img src={imgMemberCdo} alt="" />
              </div>
              <div className='member-item__text'>
                <p className='member-text__post'>Designer</p>
                <p className='member-text__name'>Ayano Terada</p>
                <p className='member-text__detail'>Delivering Creative and Impactful Designs for Both Local and Global Markets.</p>
              </div>
            </div>
          </div>
        </section>
        <section className='imformation'>
          <div className="title">
            <p className='title-lead'>COMPANY</p>
            <h2>Company Information</h2>
          </div>
          <table className='imformation-box'>
            <tbody>
              <tr>
                <th>Company Name</th>
                <td>LOGOT UG</td>
              </tr>
              <tr>
                <th>Representative</th>
                <td>Shinzo Hata</td>
              </tr>
              <tr>
                <th>Contact</th>
                <td><a href="mailto:info@logot.de" class="button-underLine" target="_brank">info@logot.de</a></td>
              </tr>
              <tr>
                <th>Founded</th>
                <td>29.05.2024</td>
              </tr>
              <tr>
                <th>Service</th>
                <td>
                  <ul className='list-disc'>
                    <li>Custom Printing</li>
                    <li>Digital Marketing</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>Company Info</th>
                <td>
                  <ul className='list-disc'>
                    <li>Umsatzsteuer-Identifikationsnummer<br />DE369420397</li>
                    <li>Registergericht: Amtsgericht Düsseldorf<br />HRB 106102</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <Cta></Cta>
      </main >
      <Footer></Footer>
    </>
  );
};

export default CompanyEn
